module.exports = __webpack_public_path__ + "static/media/brainstorm-with-peers.15949a7f.svg";